import React, {useContext} from 'react';
import { Container } from 'react-bootstrap';
import { SidebarContext } from '../../context/SidebarContext';

function Footer() {
  const {sidebarOpen} = useContext(SidebarContext);
  return (
    <footer
      className="py-2"
      style={{
        backgroundColor: '#003366',
        color: '#fff',
        borderTop: '4px solid #FFD700',
        marginLeft: sidebarOpen ? '260px' : '0px',
        minHeight: 'var(--footer-height)',
        display: 'flex',
        alignItems: 'center',
        transition: 'margin-left 0.3s ease'
      }}
    >
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: 'nowrap' }}>
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <h5 className="fw-bold mb-0" style={{ color: '#fff', fontSize: '1rem' }}>UVTAB</h5>
            <p className="mb-0" style={{ color: '#fff', fontSize: '0.9rem' }}>
              Uganda Vocational and Technical Assessment Board
            </p>
          </div>
          <div>
            <p className="mb-0" style={{ color: '#fff', fontSize: '0.9rem' }}>
              &copy; {new Date().getFullYear()} UVTAB. All rights reserved.
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
